import { useContext } from 'react';
import LanguageProvider from '@/contexts/language';

const useLanguage = () => {
  const value = useContext(LanguageProvider);

  return value;
};
    
export default useLanguage;